import { action, computed, makeObservable } from 'mobx'
import ModalViewModel from 'infra/ModalViewModelSansDecorators'
import { JobScopeItem } from 'jobs/Job'

export interface ServiceItem {
  name: string
  quantity: number
}

export default class ServiceItemListViewModel extends ModalViewModel {
  constructor(private jobScopeItems: JobScopeItem[]) {
    super()
    makeObservable(this, {
      serviceItems: computed,
      toggleShowing: action.bound,
    })
  }

  /**
   * Returns a list of service items.
   * @returns
   */
  get serviceItems(): ServiceItem[] {
    return this.jobScopeItems
      .filter((item) => item.bundle_id === null)
      .map((item) => ({
        name: item.name,
        quantity: item.quantity,
      }))
  }

  /**
   * Toggles whether the dialog is open.
   */
  toggleShowing() {
    this.showing = !this.showing
  }
}
